import store from '../store';
import * as types from '../actions/modal-actions';

class ModalApi {
	/**
	 * Shows modal
	 */
	static showModal(modal) {
		store.dispatch({
			type: types.SHOW_MODAL,
			modal
		});
		return Promise.resolve(modal);
	}

	/**
	 * Hides modal
	 */
	static hideModal(hide) {
		store.dispatch({
			type: types.HIDE_MODAL
		});
		return Promise.resolve(hide);
	}
}

export default ModalApi;






// WEBPACK FOOTER //
// ./src/api/modal-api.js